import React, { FC, ReactNode } from 'react';

import Lottie from 'lottie-react';

import styled from 'styled-components';

//theme
import aampeTheme from '../../../constants/aampeTheme';

//components
import EmptyStateText from '../../emptyStates/AampeEmptyStateText';

interface EmptyStateProps {
    text?: string;
    lottie: Object;
    className?: string;
    summary?: ReactNode;
    emptyStateStyle?: React.CSSProperties;
    lottieStyle?: React.CSSProperties;
}
const LottieInsert: FC<React.PropsWithChildren<EmptyStateProps>> = ({
    text,
    lottie,
    className,
    summary,
    emptyStateStyle,
    lottieStyle,
}) => {
    return (
        <Container className={className}>
            <Lottie
                animationData={lottie}
                loop={true}
                style={{
                    height: '160px',
                    width: '160px',
                    ...lottieStyle,
                }}
            />
            {text && (
                <TextContainer>
                    <EmptyStateText style={emptyStateStyle}>
                        {text}
                    </EmptyStateText>
                    {summary && summary}
                </TextContainer>
            )}
        </Container>
    );
};
const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => !['backgroundColor'].includes(prop),
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: aampeTheme.colors.white,
    minHeight: '100px',
    padding: aampeTheme.spacing4(8, 6),
    gap: aampeTheme.spacing4(6),
});

const TextContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(8),
});

export default LottieInsert;
